// src/hooks/useAuthCheck.js
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const useAuthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const token = Cookies.get('token') || localStorage.getItem('token');
      if (!token) {
        // Token expired or removed, redirect to login
        navigate('/', { replace: true });
      }
    }, 1000 * 60); // check every 1 minute

    return () => clearInterval(interval); // cleanup on unmount
  }, [navigate]);
};

export default useAuthCheck;
